export default "__VITE_ASSET__0n2noKD$__"